import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, NineSlicePlane, Sprite, TextStyle, Text, DEG_TO_RAD } from "pixi.js";
import tools from "tools";
export default class BoosterBtn extends Container {
  constructor(texture, boosterType, id) {
    super();
    tools.autobind(this);
    this.maxScale = 1;
    this.texture = texture;
    this.boosterBg = assets.textures.boosterBg;
    this.boosterBuyBg = assets.textures.boosterBuyBg;
    this.boosterCounterBg = assets.textures.boosterCounterBg;
    this.coinsBg = assets.textures.coins;
    this._id = id;
    this._counter = 0;
    this._coins = 0;
    this._isDown = false;
    this._boosterType = boosterType;
    this.container = new Container();
    this.addChild(this.container);
    this.lockContainer = new Container();
    this.addChild(this.lockContainer);
    this._init();
    this._initEvents();
  }
  setMaxScale(sc) {
    this.maxScale = sc;
    gsap.to(this.scale, {
      duration: .2,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale
    });
  }
  _initEvents() {
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', this._onDown);
    this.on('pointerup', this._onUp);
    this.on('pointerupoutside', this._onOut);
  }
  _onDown() {
    if (!config.touchAccess) {
      return;
    }
    if (this._isDown) {
      return;
    }
    this._isDown = true;
    this.onDownTween = gsap.to(this.scale, {
      duration: .4,
      x: .93 * this.maxScale,
      y: .93 * this.maxScale,
      ease: "back.out(10)"
    });
  }
  _onUp() {
    if (!config.touchAccess) {
      return;
    }
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale
    });
    if (this._counter > 0) {
      config.boosterRvPopin.hide();
      this.emit("onClick", {
        type: this._boosterType
      });
    } else {
      if (config.coins >= this._coins) {
        config.level.updateCoins(-this._coins);
        this.incCounter();
      } else {
        config.boosterRvPopin.show();
      }
    }
  }
  _onOut() {
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale
    });
  }
  _init() {
    this.bg = new Sprite(this.boosterBg.texture);
    this.bg.anchor.set(.5);
    this.container.addChild(this.bg);
    this.bg.visible = false;
    this.img = new Sprite(this.texture);
    // this.img.scale.set(.5);
    this.img.y = -12;
    this.img.anchor.set(.5);
    this.container.addChild(this.img);
    this.counterBg = new Sprite(this.boosterCounterBg.texture);
    this.counterBg.anchor.set(.5);
    this.counterBg.y = 45;
    this.counterBg.visible = false;
    this.container.addChild(this.counterBg);
    const counterStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 30,
      fill: '#666666'
    });
    this.counterText = new Text(this._counter, counterStyle);
    this.counterText.anchor.set(.5);
    this.counterBg.addChild(this.counterText);
    const coinsStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 30,
      fill: '#ffffff',
      stroke: '#000000',
      strokeThickness: 2,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 2,
      dropShadowColor: '0x000000',
      dropShadowDistance: 2
    });
    this.boosterBuyBg = new NineSlicePlane(this.boosterBuyBg.texture, 20, 20, 21, 27);
    this.boosterBuyBg.width = 114;
    this.boosterBuyBg.x = -57;
    this.boosterBuyBg.y = 20;
    this.boosterBuyBg.visible = false;
    this.container.addChild(this.boosterBuyBg);
    this.coinsImg = new Sprite(this.coinsBg.texture);
    this.coinsImg.x = -this.coinsImg.width * 0.25;
    this.coinsImg.y = 0;
    this.boosterBuyBg.addChild(this.coinsImg);
    this.coinsText = new Text(this._coins, coinsStyle);
    this.coinsText.anchor.x = .5;
    this.coinsText.x = 76;
    this.coinsText.y = 2;
    this.boosterBuyBg.addChild(this.coinsText);
    this.lockSprite = new Sprite(assets.textures.boosterLock.texture);
    this.lockSprite.anchor.set(.5);
    // this.lockSprite.tint = 0xbbd3eb;
    this.lockContainer.addChild(this.lockSprite);
    this.lockSub = new Sprite(assets.textures.locksub.texture);
    this.lockSub.anchor.set(.5);
    this.lockContainer.addChild(this.lockSub);
    this.lockSub.position.set(this.lockSprite.x, 45);
    const lockStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#000000'
    });
    this.lockText = new Text("Level", lockStyle);
    this.lockText.anchor.set(0.5, 0.5);
    this.lockText.position.set(this.lockSub.x - 15, this.lockSub.y);
    this.lockContainer.addChild(this.lockText);
    const levelStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#000000'
    });
    this.levelLockText = new Text(assets.gameConfig.boosterLevelPalier[this._id], levelStyle);
    this.levelLockText.anchor.set(.5);
    this.levelLockText.position.set(this.lockSub.x + 30, this.lockSub.y);
    this.lockContainer.addChild(this.levelLockText);
    this.lock = false;
  }
  incCounter(val) {
    if (val) {
      this.counter = val;
    } else {
      this.counter++;
    }
    config.sdk.getStoreModule().save(this._boosterType, {
      value: this.counter
    });
  }
  set counter(val) {
    this._counter = val;
    this.counterText.text = this._counter;
    if (this._counter > 0) {
      this.boosterBuyBg.visible = false;
      this.counterBg.visible = true;
      gsap.to(this.scale, {
        duration: .15,
        x: 1.2 * this.maxScale,
        y: 1.2 * this.maxScale
      });
      gsap.to(this.scale, {
        delay: .15,
        duration: .5,
        x: 1 * this.maxScale,
        y: 1 * this.maxScale
      });
    } else {
      this.boosterBuyBg.visible = true;
      this.counterBg.visible = false;
    }
  }
  get counter() {
    return this._counter;
  }
  set coins(val) {
    this._coins = val;
    this.coinsText.text = this._coins;
  }
  get coins() {
    return this._coins;
  }
  set tint(color) {
    this.bg.tint = color;
    this.img.tint = color;
    this.counterBg.tint = color;
    this.coinsBg.tint = color;
    this.boosterBuyBg.tint = color;
  }
  set greyMode(val) {
    this._greyMode = val;
    if (val) {
      this.boosterBuyBg.texture = assets.textures.boosterBuyGreyBg.texture;
    } else {
      this.boosterBuyBg.texture = assets.textures.boosterBuyBg.texture;
    }
  }
  get greyMode() {
    return this._greyMode;
  }
  set lock(val) {
    this.container.visible = !val;
    this.interactive = !val;
    this.buttonMode = !val;
    this.lockContainer.visible = val;
    this._lock = val;
  }
  get lock() {
    return this._lock;
  }
  update() {}
}
